import { render } from "./AdminBanner.vue?vue&type=template&id=0fb038ba&scoped=true"
import script from "./AdminBanner.vue?vue&type=script&lang=js"
export * from "./AdminBanner.vue?vue&type=script&lang=js"

import "./AdminBanner.vue?vue&type=style&index=0&id=0fb038ba&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb038ba"]])

export default __exports__